import { default as Dialog } from './Dialog';
import { default as Form } from './Form';

export { Dialog, Form };
